import { useState } from 'react';
import axios from 'axios';
import { API } from '@/App';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import { LogIn } from 'lucide-react';

const Login = ({ onLogin }) => {
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/auth/login`, { 
        username: formData.username, 
        password: formData.password 
      });
      onLogin(response.data.user, response.data.token);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erro ao fazer login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Logo Card - Apenas logo, sem texto */}
        <div className="bg-white rounded-2xl shadow-sm p-8 mb-6 text-center border-2 border-[#D87A4E]/30">
          <img 
            src="/logo.png" 
            alt="Sistema de Gestão SCFV" 
            className="w-64 h-64 mx-auto object-contain"
          />
          <p className="text-slate-600 mt-4">Sistema de Gestão SCFV</p>
        </div>

        {/* Login Form - Sem opção de cadastro */}
        <div className="bg-white rounded-2xl shadow-sm p-8 border-2 border-[#D87A4E]/30">
          <div className="flex items-center justify-center gap-2 mb-6">
            <LogIn className="h-5 w-5 text-[#D87A4E]" />
            <h2 className="text-xl font-semibold text-slate-800">Acesso ao Sistema</h2>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label htmlFor="username">Usuário</Label>
              <Input
                id="username"
                data-testid="username-input"
                value={formData.username}
                onChange={(e) => setFormData({ ...formData, username: e.target.value })}
                required
                placeholder="Digite seu usuário"
              />
            </div>

            <div>
              <Label htmlFor="password">Senha</Label>
              <Input
                id="password"
                type="password"
                data-testid="password-input"
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                required
                placeholder="••••••••"
              />
            </div>

            <Button
              type="submit"
              className="w-full bg-[#D87A4E] hover:bg-[#c26a42]"
              disabled={loading}
              data-testid="submit-button"
            >
              {loading ? 'Processando...' : 'Entrar'}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;